import routerOptions0 from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  scrollBehaviorType: "smooth",
  hashMode: false
}
export default {
...configRouterOptions,
...routerOptions0,
}